'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fp = require('lodash/fp');

var _lodash = require('lodash');

var _bindSelector = (0, _fp.curry)(function (selectionName, selector) {
  return (0, _fp.flow)((0, _fp.get)(selectionName), selector);
});

var bindToSelection = function bindToSelection(actions, selectors) {
  return function () {
    var selectionName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'selection';

    var boundActions = (0, _fp.mapValues)(function (actionCreator) {
      return (0, _lodash.bind)(actionCreator, null, selectionName);
    }, actions);
    var boundSelectors = (0, _fp.mapValues)(_bindSelector(selectionName), selectors);
    return {
      actions: boundActions,
      selectors: boundSelectors
    };
  };
};

exports.default = bindToSelection;


//////////////////
// WEBPACK FOOTER
// ./~/yourchoice-redux/lib/bindToSelection.js
// module id = 157
// module chunks = 0